module.exports = [{"key":"fullstackDeveloper","title":"Full stack developer","fileName":"developer.md"},{"key":"SEO","title":"מקדם/ת אתרים SEO","fileName":"seo.md"},{"key":"telemarketing","title":"נציגי/ות טלמרקטינג אגף שיווק החברה","fileName":"telemarketing.md"},{"key":"QA","title":"בודק/ת תוכנה QA","fileName":"qa.md"},{"key":"sales","title":"אנשי/נשות מכירות שטח","fileName":"sales.md"}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/JobsPage/vacancies.json
// module id = 1892
// module chunks = 0